import {registerBrick} from 'olympe';
import {ReactBrick, useProperty} from '@olympeio/core';
import React from 'react';

export default class IframeBrick extends ReactBrick {
    /**
     * @override
     * @protected
     * @param {!BrickContext} $
     * @param {!Array<*>} properties
     * @return {Element}
     */
    static getReactComponent($) {
        return (props) => {
            const loading = useProperty($, 'Loading', true);
            const title = useProperty($, 'Title', false);
            const src = useProperty($, 'URL', true);
            const height = useProperty($, 'Height', true);
            const width = useProperty($, 'Width', true);
            const hidden = useProperty($, 'Hidden', true);
            const onLoad = useProperty($, 'On Load', false);

            const handleOnLoad = (event) => {
                const [ctrlFlowInput, eventInput] = onLoad.getInputs();

                const runner = $.runner(onLoad);
                runner.set(eventInput, event);
                runner.trigger(ctrlFlowInput);
            };

            return (
                !hidden ?
                    <>
                        <iframe
                            src={src}
                            name={'hidden_iframe'}
                            title={title}
                            loading={loading}
                            width={width}
                            height={height}
                            style={{border: '0'}}
                            onLoad={handleOnLoad}
                        ></iframe>
                    </> : null

            );
        };
    }
}

registerBrick('0190737c7c4deddbb7b8', IframeBrick);
